<template>
  <div v-if="blok.title" class="content-feature">
    <SbIcon v-if="blok.icon" :name="blok.icon" class="content-feature__icon" />
    <h3 class="content-feature__title">{{ blok.title }}</h3>
    <p class="content-feature__text">{{ blok.text }}</p>
  </div>
</template>

<script setup lang="ts">
import { SbIcon } from '@storyblok/design-system'
import type { IconName } from '@storyblok/design-system'

defineProps<{
  blok: {
    icon: IconName
    title: string
    text: string
  }
  title: string
  id: string
}>()
</script>

<style lang="scss">
.content-feature {
  display: flex;
  flex-direction: column;
  gap: $sb-size-unit-lg;
  align-items: flex-start;
  color: $sb-color-text-secondary;

  &__icon {
    color: $sb-color-text-primary;
  }

  &__title {
    color: $sb-color-text-primary;
    font-size: $sb-font-size-base;
    font-weight: $sb-font-weight-bold;
  }

  &__text {
    line-height: $sb-font-line-height-distant;
  }
}
</style>
